export default __webpack_public_path__ + "static/media/FCEL.916a603c.png";